import { money } from "../../lib/api";

const DONE = ["paid", "shipped", "collected"];

export const receivedFor = (o) => (DONE.includes(o.status) ? Number(o.total ?? 0)
  : o.status === "awaiting_payment" ? Number(o.amount_paid ?? 0) : 0);

const Stat = ({ id, label, value, sub, bg }) => (
  <div data-testid={`admin-stat-${id}`} className="rounded-[20px] border-2 border-[var(--ink)] shadow-[3px_3px_0_#14101F] p-4" style={{ background: bg }}>
    <p className="text-xs font-mono-x uppercase tracking-[0.14em] font-bold">{label}</p>
    <p className="font-display font-extrabold text-3xl sm:text-4xl leading-none mt-2">{value}</p>
    {sub && <p className="text-sm mt-1.5">{sub}</p>}
  </div>
);

export const AdminStats = ({ orders, requests }) => {
  const by = (s) => orders.filter((o) => o.status === s);
  const unpaid = by("awaiting_payment");
  const owed = unpaid.reduce((s, o) => s + Number(o.total ?? 0) - Number(o.amount_paid ?? 0), 0);
  const received = orders.reduce((s, o) => s + receivedFor(o), 0);
  const completed = by("shipped").length + by("collected").length;

  return (
    <section data-testid="admin-stats" className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-8">
      <Stat id="total" label="Total orders" value={orders.length} sub={`${by("cancelled").length} cancelled`} bg="#fff" />
      <Stat id="unpaid" label="Unpaid" value={unpaid.length} sub={`${money(owed)} still owed`} bg="var(--yellow)" />
      <Stat id="paid" label="Paid - to print" value={by("paid").length} sub="Ready for the printer" bg="var(--lime)" />
      <Stat id="completed" label="Completed" value={completed} sub={`${by("shipped").length} shipped · ${by("collected").length} collected`} bg="var(--cyan)" />
      <Stat id="received" label="Money received" value={money(received)} sub="Paid orders + plan payments" bg="#fff" />
      <Stat id="requests" label="New custom requests" value={requests.filter((r) => r.status === "new").length} sub={`${requests.length} requests in total`} bg="var(--pink)" />
    </section>
  );
};
